import './bgGlobal.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { HashRouter as Router, Routes, Route, Navigate  } from "react-router-dom";

import Home from "./pages/Home/PageHome"
import NotaFiscal from './components/PortalHome/NotaFiscal';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';
import Dashboard from './pages/Dashboard';
import DetalheOS from './pages/DetalheOS';
import PageContabilidade from './pages/Contabilidade';
import DetalheCredenciaisDeAcesso from './pages/CredenciaisAcesso';
import ZapMei from './pages/ZapMei';
import ContratarZapMei from './pages/ContratarZapMei';
import PageOpenFinance from './pages/OpenFinance';
import PageCertificado from './pages/CertificadoDigitalMCO';
import PageMovimentacaoFinanceira from './pages/MovimentacaoFinanceira';
import TamplateLandingPage from './pages/TamplateLandingPage';
import PageDashboardContabilidade from './pages/DashboardContabilidade';

import RedirectToHtml from "./components/RedirectToHtml";

function App() {
  return (
    <>
      <ConfigProvider locale={ptBR}>

        <ToastContainer />

        <Router>
          <main id="main-content">
            <Routes>
              <Route path="/" element={<ZapMei />} />
              <Route path="home" element={<Home />} />
              <Route path="PortalNFSECliente" element={<NotaFiscal />} />
              <Route path="Dashboard" element={<Dashboard />} />
              <Route path="DetalheOS/:id" element={<DetalheOS />} />
              <Route path="DetalheCredenciaisDeAcesso/:id" element={<DetalheCredenciaisDeAcesso />} />
              <Route path="Contabilidade" element={<PageContabilidade />} />
              <Route path="ZapMei" element={<ZapMei />} />
              <Route path="ContratarZapMei" element={<ContratarZapMei />} />
              <Route path="Openfinance/:clienteId" element={<PageOpenFinance />} />
              <Route path="CertificadoDigital" element={<PageCertificado />} />
              <Route path="MovimentacaoFinanceira" element={<PageMovimentacaoFinanceira />} />
              <Route path="DashboardContabilidade" element={<PageDashboardContabilidade />} />

              {/*TESTEANDO FUNCIONALIDADE DO MESMO COMPONENT PARA ESSAS DUAS PAGES */}
              <Route path="/corretor" element={<TamplateLandingPage />} />
              <Route path="/corretor/:url_section" element={<TamplateLandingPage />} />
              <Route path="zapmeiTeste" element={<TamplateLandingPage />} />


             { /*TUTORIAL DP */}
             <Route
              path="/guiacontratacao"
              element={<RedirectToHtml />}
            />


            </Routes>
          </main>
        </Router>

      </ConfigProvider>
    </>
  );
}

export default App;